import { useState } from 'react';
import { ReactCompareSlider, ReactCompareSliderImage, ReactCompareSliderHandle } from 'react-compare-slider';

const BeforeAfterSlider = ({ 
  beforeImage, 
  afterImage, 
  beforeLabel = "Before",
  afterLabel = "After",
  className = "",
  aspectRatio = "1/1",
  initialPosition = 75
}) => {
  const [position, setPosition] = useState(initialPosition);

  // Hide Before label when slider line reaches/passes the pill (left side ~18%)
  // Hide After label when slider line reaches/passes the pill (right side ~82%)
  const showBeforeLabel = position > 18;
  const showAfterLabel = position < 82;

  return (
    <div className={`relative overflow-hidden rounded-2xl ${className}`} style={{ aspectRatio }}>
      <ReactCompareSlider
        itemOne={
          <ReactCompareSliderImage
            src={beforeImage}
            alt={beforeLabel}
            style={{ objectFit: 'cover', width: '100%', height: '100%' }}
          />
        }
        itemTwo={
          <ReactCompareSliderImage
            src={afterImage}
            alt={afterLabel}
            style={{ objectFit: 'cover', width: '100%', height: '100%' }}
          />
        }
        handle={
          <ReactCompareSliderHandle
            buttonStyle={{
              backgroundColor: '#0a2540',
              border: '3px solid white',
              boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
              width: 44,
              height: 44,
            }}
            linesStyle={{
              width: 3,
              backgroundColor: 'white',
              boxShadow: '0 0 8px rgba(0,0,0,0.4)',
            }}
          />
        }
        position={initialPosition}
        onPositionChange={setPosition}
        style={{ height: '100%' }}
      />
      
      {/* Labels - Before on left, After on right - disappear when slider touches them */}
      {showBeforeLabel && (
        <div className="absolute top-4 left-4 bg-black/60 backdrop-blur-sm text-white text-sm font-medium px-3 py-1.5 rounded-full transition-opacity duration-150">
          {beforeLabel}
        </div>
      )}
      {showAfterLabel && (
        <div className="absolute top-4 right-4 bg-[#d4af37] text-[#0a2540] text-sm font-bold px-3 py-1.5 rounded-full transition-opacity duration-150">
          {afterLabel}
        </div>
      )}
    </div>
  );
};

export default BeforeAfterSlider;
